/**
 * List Targeting Feature
 * @module
 */

/**
 * PluginManager registration method
 * @param {PluginManager} PluginManager
 */
module.exports = function(PluginManager:PluginManagerClass) {
  PluginManager.registerDependency('sources/odds', require('./sources/list_targeting'));

  PluginManager.registerVisitorProfileProvider(require('./providers/lists'));

  PluginManager.registerAudienceMatcher('list', require('./matchers/list'));
};
